module.exports = __webpack_public_path__ + "static/media/coffer_logo.f4372d7b.svg";